import React from 'react';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';

export const BoolValueCellRenderer = ({ value, msgIdPrefix }) => {
    const msgId = `${msgIdPrefix}.${value}`;
    return <FormattedMessage id={msgId} />;
};
